import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from '../../lib/i18n';
import { PAGE_PATH } from '../../lib/constants';
import { MainContainer, ToTopButton } from './styles/LoginFailureStyles';

/**
 * エラーコードに対応するエラーメッセージを生成
 * @param {string} errorCode - エラーコード
 * @param {string} locale - ロケール
 * @returns {ReactElement}
 */
const generateErrorMessage = (errorCode, locale) => {
  const i18nMessages = messages[locale];
  const errorCodeString = `login.oauth2.error.${errorCode}`;
  const isError = i18nMessages[errorCodeString];
  return isError ? (
    JSON.parse(isError).map((str, idx) => (
      <div key={`errorMessage${idx + 0}`}>{str}</div>
    ))
  ) : (
    <FormattedMessage id="login.oauth2.error.unknown" />
  );
};

/**
 * ログイン失敗画面
 * @param {Object} props
 * @param {Object} props.match - ルーティング情報(現在のURLの情報含む)
 * @param {string} props.locale - ロケール
 * @returns {ReactElement}
 */
const LoginFailure = ({ match = {}, locale }) => {
  const { params: { errorCode } = {} } = match;
  const errorMessage = generateErrorMessage(errorCode, locale);
  return (
    <MainContainer>
      {errorMessage}
      <div id="forceLogoutButton" role="presentation">
        <ToTopButton to={PAGE_PATH.DS_LOGOUT} className="button">
          <FormattedMessage id="login.oauth2.button.logout" />
        </ToTopButton>
      </div>
    </MainContainer>
  );
};

LoginFailure.propTypes = {
  match: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  locale: state.main.locale,
});

export default withRouter(connect(mapStateToProps)(LoginFailure));
